import * as React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Divider from 'material-ui/Divider';
import { withProps, compose, withHandlers, withState } from 'recompose';

import { InlineGrid, InlineGridField } from '@components/form';
import { EventsFormFilesForm } from '@modules/events/EventsFormFilesForm';
import { filesGridColumns } from '@modules/events/_eventsColumns';
import { ActionBar } from './EventsFormFilesActionBar';
import { addReportToEvent } from './_eventsActions';
import { withNotifications } from '@components/hoc/withNotifications';
import { Loader } from '@components/loader';

const enhance = compose<any, any>(
  withState('loader', 'setLoader', false),
  withNotifications({ addReportToEvent }),
  withHandlers({
    // after export report submit
    afterSubmit: ({ reloadEvent, addReportToEventNotify, setLoader }) => async (eventId, report, data) => {
      setLoader(true);
      await addReportToEventNotify(eventId, report.id, data);
      setLoader(false);
      reloadEvent();
    }
  })
);

const View: React.SFC<any> = ({ eventId, reloadEvent, disabled, locked, afterSubmit, setDisableSps, loader }) => (
  <div>
    {loader && <Loader />}
    <Grid fluid={true}>
      <Row>
        <Col md={12}>
          <h4>Soubory</h4>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <InlineGridField
            component={InlineGrid}
            name="files"
            ActionBar={withProps({ eventId, reloadEvent, disabled, locked, afterSubmit, setDisableSps })(ActionBar)}
            Form={withProps({ eventId, setDisableSps })(EventsFormFilesForm)}
            columns={filesGridColumns}
            showCheckboxes={true}
            adding={!locked}
            editing={!locked}
            deleting={!locked}
            onDelete={() => setDisableSps(true)}
          />
        </Col>
      </Row>
    </Grid>

    <Divider />
  </div>
);

export default enhance(View);



// WEBPACK FOOTER //
// ./src/modules/events/EventsFormFiles.tsx